import { buildFilter } from './filters/buildFilter';

/** Canonical list of jane-defined row types. */
export const JANE_DEFINED_ROWS = [
  'buy_again_row',
  'sale',
  'best_selling',
  'brand_specials',
  'specials',
  'magic_row',
];

/** Template-backed rows: store-scoped root types keyed off `menu_row_type`, not `row_type`. */
const MENU_ROW_TEMPLATES = ['new_products'];

interface CustomRowSetting {
  display_name?: string | null;
  id?: number;
  menu_row_type: string;
  row_type?: string;
}

export const resolveRowId = (
  placementRowId: number | undefined,
  title: string | undefined,
  customRowSettings: readonly CustomRowSetting[] | undefined
): number | undefined => {
  if (placementRowId) return placementRowId;

  if (title && customRowSettings) {
    const match = customRowSettings.find((r) => r.display_name === title);
    if (match?.id) return match.id;
  }

  return undefined;
};

export const getRowRootType = (row: CustomRowSetting, storeId: number) => {
  const isTemplatedRow = MENU_ROW_TEMPLATES.includes(row.menu_row_type);
  if (isTemplatedRow) return `${row.menu_row_type}-${storeId}`;

  const rowType = row.row_type ?? '';
  const isJaneDefined = JANE_DEFINED_ROWS.includes(rowType);
  return isJaneDefined ? rowType : `${rowType}-${storeId}`;
};

export const formatFeaturedRow = (
  storeId: number,
  customRowSettings: readonly CustomRowSetting[] | undefined,
  rowId: number
): {
  featuredFilter: string;
  featuredTitle: string;
  isJaneDefined: boolean;
} => {
  const empty = { featuredTitle: '', featuredFilter: '', isJaneDefined: false };

  if (!customRowSettings) return empty;

  const row = customRowSettings.find((r) => r.id === rowId);
  if (!row?.row_type) return empty;

  const isJaneDefined = JANE_DEFINED_ROWS.includes(row.row_type);

  return {
    featuredTitle: row.display_name || row.row_type,
    featuredFilter: buildFilter('root_types', [getRowRootType(row, storeId)]),
    isJaneDefined,
  };
};
